// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/AuditHome/FormView.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/AuditHome/FormView.tsx");
  import.meta.hot.lastModified = "1732036225888.936";
}
// REMIX HMR END

import { Fragment, useEffect } from "react";
import Form from "~/components/forms/Form";
import { useFetcher, useLoaderData, useSearchParams } from "@remix-run/react";
import { schema } from "~/routes/audit";
import SpeedTestDropdown from "../SpeedTestDropdown";
import Button from "~/components/Button";
import { resultMapping } from "../DocTahedroidImage";
import Link from "~/components/Link";
import Heading from "~/components/Heading";
export default function AuditHomeFormView() {
  _s();
  const loader = useLoaderData();
  const fetcher = useFetcher();
  const [searchParams, setSearchParams] = useSearchParams();
  useEffect(() => {
    if (fetcher.data && fetcher.data.url && fetcher.data.type) {
      const params = new URLSearchParams();
      params.set("url", fetcher.data.url);
      params.set("reportType", fetcher.data.type);
      if (fetcher.data.device) {
        params.set("device", fetcher.data.device);
      }
      setSearchParams(params, {
        preventScrollReset: true
      });
    }
  }, [fetcher.data, setSearchParams]);
  const {
    speed: {
      title,
      message
    }
  } = resultMapping.default;
  const hasAuditError = loader.audit?.error;
  return <Fragment>
      <hgroup className="mb-4">
        <Heading tag="h2">{title}</Heading>
        <p className="text-neutral-600">{message}</p>
      </hgroup>

      <Form schema={schema} action="/audit" method="post" className="w-full mb-4" mode="onBlur" fetcher={fetcher} errors={hasAuditError ? {
      url: ["URL not found. Try again."]
    } : undefined} hiddenFields={["intent"]} values={{
      url: searchParams.get("url") || "",
      intent: searchParams.get("reportType") || "metrics:mobile"
    }}>
        {({
        Field,
        setValue,
        submit
      }) => {
        const handleAudit = intent => {
          setValue("intent", intent);
          submit();
        };
        return <Fragment>
              <fieldset className="w-full flex flex-col gap-4">
                <Field className="grow" name="url" onKeyDown={e => {}}>
                  {({
                SmartInput,
                Errors
              }) => <Fragment>
                      <SmartInput placeholder="Website URL" />
                      <Errors />
                    </Fragment>}
                </Field>
                <Field name="intent" />
                <div className="flex gap-3 self-end grow md:grow-0">
                  <SpeedTestDropdown onSelectOption={option => handleAudit(option)} />
                  <Button type="button" variant="tertiary" className="shrink-0 grow md:grow-0" onClick={() => handleAudit("opengraph")}>
                    Meta Tags
                  </Button>
                </div>
              </fieldset>
            </Fragment>;
      }}
      </Form>
      <p className="text-xs text-neutral-600">
        *Depending on your site's eligibility and current status, Doc. Tahedroid
        will procure your web performance report from either Google's Chrome UX
        Report or Lighthouse Performance Audit.{" "}
        <Link to="/audit#Understand Your Performance Metrics">
          Click here for more information.
        </Link>
      </p>
    </Fragment>;
}
_s(AuditHomeFormView, "UNPNeFYBMJcL8QwIRc029V44uJU=", false, function () {
  return [useLoaderData, useFetcher, useSearchParams];
});
_c = AuditHomeFormView;
var _c;
$RefreshReg$(_c, "AuditHomeFormView");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;